import React, { Component } from 'react';
import { GET_FIRST_LETTER  } from '../../../utils';

class ProfileImage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            profileError: false
        }
    }

    getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }
    render() {
        const { profileError } = this.state;
        const { imageSize, symbolClass, className, name, profileUrl, color } = this.props;
        return <div className={className}>
            {profileError || (profileUrl == "") ?
                <span className={symbolClass} style={{ backgroundColor: color }}>{GET_FIRST_LETTER(name)}</span>
                :
                <img src={profileUrl} height={imageSize} width={imageSize} alt={name} onError={() => this.setState({ profileError: true })} />
            }
        </div>
    }
}

export default ProfileImage;